export default __webpack_public_path__ + "static/media/phone.6df39f8a.svg";